import React, { Component } from 'react';
import '../SideDraw/folders.css';
//import updateWorkplace from '../../../images/icons/updateWorkplace.png';
import { Tooltip } from 'devextreme-react/tooltip';

//import * as updateWorkplace from "../../../images/icons/Refresh.svg";
import * as collapseContext from "../../../images/icons/ContextPanelCollapse.svg";



class CollapseContext extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //defaultVisible: false,
            withAnimationVisible: false,
            //withTemplateVisible: false
        };

        this.toggleWithAnimation = this.toggleWithAnimation.bind(this);

    }

    render() {

        return (
            <div>
                <img
                    id="product5"
                    onMouseEnter={this.toggleWithAnimation}
                    onMouseLeave={this.toggleWithAnimation}
                    style={{ height: '21px', width: '32px', zIndex: 10, color: "#fff", marginTop: '0px', marginLeft: '-11px', color: '#2999E3' }}
                    src={collapseContext} />
                <Tooltip
                    target="#product5"
                    position="top"
                    //animation={animationConfig}
                    visible={this.state.withAnimationVisible}
                    closeOnOutsideClick={false}
                >
                    <div>Collapse Context</div>
                </Tooltip>
            </div>
        );
    }
    toggleWithAnimation() {
        this.setState({
            withAnimationVisible: !this.state.withAnimationVisible
        });
    }
}
export default CollapseContext;





// WEBPACK FOOTER //
// ./src/components/TaskView/WorkPlace/CollapseContext.js